import { Link, Stack, Typography } from '@mui/material';
import { SearchPeopleProfile } from 'modules/sourcing-external/types/SearchPeopleQueryItem';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useSourcingExternalStore } from 'modules/sourcing-external/stores';
import { Checkbox } from 'common/form/components/Checkbox';
import { TablePagination } from '@mui/material';
import { useTracking } from 'services/tracking/hooks';
import { TrackingEventName } from 'services/tracking/constants';
import { SourcingExternalContactOutProfile } from 'modules/sourcing-external/components/SourcingExternalContactOutProfile';

export const SourcingExternalSearchDrawer: React.FC<{
  row: SearchPeopleProfile;
  currentIndex: number;
  total: number;
  onNext?: () => void;
  onPrev?: () => void;
}> = ({ row, currentIndex, total, onNext, onPrev }) => {
  const candidateBatch = useSourcingExternalStore(
    (state) => state.candidateBatch
  );
  const selectedRows = useSourcingExternalStore((state) => state.selectedRows);
  const alreadyInvitedRows = useSourcingExternalStore(
    (state) => state.alreadyInvitedRows
  );
  const onSelectRow = useSourcingExternalStore((state) => state.onSelectRow);
  const onRemoveSelectedRow = useSourcingExternalStore(
    (state) => state.onRemoveSelectedRow
  );
  const { track } = useTracking();

  const selectedRow = selectedRows.find(
    (selectedRow) => selectedRow.linkedInProfileUrl === row.linkedInProfileUrl
  );

  const isAlreadyInvited = alreadyInvitedRows.find(
    (alreadyInvitedRow) =>
      alreadyInvitedRow.linkedInProfileUrl === row.linkedInProfileUrl
  );

  const handleSelectRow = (row: SearchPeopleProfile) => {
    if (!candidateBatch) return;

    if (selectedRow) {
      onRemoveSelectedRow(selectedRow);
    } else {
      onSelectRow(candidateBatch, row);
    }
  };

  return (
    <Stack gap="40px" py="10px">
      <Link
        href={row.linkedInProfileUrl ?? ''}
        target="_blank"
        sx={{
          p: 0,
          gap: '8px',
          w: 'fit',
          color: 'primary.main',
          fontWeight: 500,
          textDecoration: 'none',
          alignItems: 'center',
          display: 'flex'
        }}
        onClick={() =>
          track(TrackingEventName.SourcingLinkedInProfileClick, {
            candidateBatchId: candidateBatch?.id,
            linkedInProfileUrl: row.linkedInProfileUrl
          })
        }
      >
        View LinkedIn profile <OpenInNewIcon />
      </Link>
      <Stack flexDirection="row" alignItems="center" width="100%">
        {isAlreadyInvited ? (
          <Typography variant="defaultEmphasis" sx={{ width: '300px' }}>
            Already invited
          </Typography>
        ) : (
          <Checkbox
            value={!!selectedRow}
            onChange={() => handleSelectRow(row)}
            field={{
              checkboxLabel: 'Invite to apply',
              controlSx: {
                color: 'primary.main'
              }
            }}
          />
        )}
        <TablePagination
          component="div"
          sx={{
            width: '400px'
          }}
          labelDisplayedRows={({ from, count }) => `${from} of ${count}`}
          count={total}
          page={currentIndex}
          rowsPerPage={1}
          rowsPerPageOptions={[]}
          onPageChange={(_, page) => {
            if (page === currentIndex + 1) {
              onNext?.();
            } else if (page === currentIndex - 1) {
              onPrev?.();
            }
          }}
        />
      </Stack>
      <SourcingExternalContactOutProfile profile={row} hideLinkedInLink />
    </Stack>
  );
};
